(() => {
  const form = document.getElementById('VSATplusDefaultCountry');
  if (!form) return;
  const key = 'vsatplus-country-choice-v1';
  try {
    if (localStorage.getItem(key)) return;
    // Record before submitting so blocked localization cannot cause a redirect loop.
    localStorage.setItem(key, 'US');
  } catch (error) {
    return; // Leave the native country selector available when storage is blocked.
  }
  if (form.querySelector('[data-current-country]').value === 'US') return;
  form.querySelector('[name="return_to"]').value =
    window.location.pathname + window.location.search + window.location.hash;
  form.submit();
})();
